var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 1.16797H5.25033C2.33366 1.16797 1.16699 2.33464 1.16699 5.2513V8.7513C1.16699 11.668 2.33366 12.8346 5.25033 12.8346H8.75033C11.667 12.8346 12.8337 11.668 12.8337 8.7513V7.58464",
    stroke: "#9094A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3566 1.76108L4.75993 6.35775C4.58493 6.53275 4.40993 6.87691 4.37493 7.12775L4.1241 8.88358C4.03076 9.51941 4.47993 9.96275 5.11576 9.87525L6.8716 9.62441C7.1166 9.58941 7.46076 9.41441 7.6416 9.23941L12.2383 4.64275C13.0316 3.84941 13.4049 2.92775 12.2383 1.76108C11.0716 0.594415 10.1499 0.967748 9.3566 1.76108Z",
    stroke: "#9094A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69727 2.42188C9.0881 3.81604 10.1789 4.90687 11.5789 5.30354",
    stroke: "#9094A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b2e65927b2fa81e09948ee5358e9e21f.svg";
export { ForwardRef as ReactComponent };